<template>
  <router-link 
    class="user-badge"
    tag="div"
    :to="{ name: 'profile' }"
  >
    <div 
      class="user-badge--image-wrapper"
      :data-emoji="user.emoji"
    >
      <div class="user-badge--image">
        <img :src="user.image">
      </div>
    </div>

    <div class="user-badge--name">
      <p>{{ user.name }}</p>
    </div>
  </router-link>
</template>

<script>
  export default {
    props: {
      user: {
        type: Object,
        required: true,
      }
    },
  }
</script>

<style lang="scss">
  .user-badge {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &--image-wrapper {
      position: relative;

      &:after {
        content: attr(data-emoji);
        position: absolute;
        right: 0px;
        bottom: 0px;
        transform: translate3d(25%, 25%, 0);
        font-size: 24px;
      }
    }

    &--image {
      position: relative;
      height: 105px;
      width: 105px;
      // border-radius: 300px;
      border-radius: 25px;
      border: 2px solid var(--color); 
      overflow: hidden;
      mask-image: radial-gradient(white, black);
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        // min-height: 100%;
        height: 100%;
      }
    }
  }
</style>